/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { blank, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { getParameterListById, saveParameterList, updateParameterListByID } from "utils/superAdminApi";
import LoadingModal from "../../../../components/LoadingModel/loadingModal";

const errMsg = {
  color: `red`,
  fontSize: `11px`
};

function AddParameterLsit() {

  const [screenName, setScreenName] = useState("Add New Parameter List");
  const [loading, setLoading] = useState(false);
  const [parameterListNameErr, setParameterListNameErr] = useState(false);
  const [parameterListCodeErr, setParameterListCodeErr] = useState(false);
  const [parameterListSequenceErr, setParameterListSequenceErr] = useState(false);
  const [disableColor,setDisableColor] = useState(false);
  const { id } = useParams();
  const { parameterId } = useParams()
const dispatch = useDispatch()
const navigate = useNavigate()

  //  const id = window.location.pathname.split('/').pop();

  const [values, setValues] = React.useState({
    roleName: "",
    roleDescription: "",
    applicableForBusinessUser: "No",
    planID: "",
    defaultPlanRole: "No",
  });

  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;

  const [parameterListValues, setParameterListValues] = React.useState({
    customValue1:"",
    customValue2:"",
    customValue3:"",
    customValue4:"",
    parameterListName: "",
    parameterListCode: "",
    parameterListSequence: "",
    parameterListStatus: "Active",
    searchParameter: '',
    searchParameterList: ['parameterListName', 'parameterListCode', 'parameterListSequence', 'parameterListStatus',]
  });



  useEffect(() => {
    if (id !== undefined) {
      console.log("ids", id)
      setScreenName("Edit Parameter List")
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue1 = urlParams.get('pr');
      parameterListValues.parameterId = paramValue1
      parameterListValues._id = id
      getParameterListById(parameterListValues , (data)=>{
        if (data.Result_Status) {
          setParameterListValues(data.Result_Output[0])
        }

      },dispatch)
    } else {
      parameterListValues.parameterId = parameterId
    }
    getRight()
  }, [])

    async function getRight() {
    let right = await getScreenRight("Parameter Lists")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }


  const handleChange = (name) => (event) => {
    
    if(name == "parameterListCode"){
      setParameterListValues({ ...parameterListValues, [name]: event.target.value.toUpperCase() });
      return
    }
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setParameterListValues({ ...parameterListValues, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setParameterListValues({ ...parameterListValues, [name]: event.target.value });
    }
  };
  const clearErrState =()=>{
    setParameterListSequenceErr(false)
    setParameterListCodeErr(false)
    setParameterListNameErr(false)
  }
  let mandateFlag;
  const addParameterList = () => {
    clearErrState()
    sessionStorage.setItem("PARA_TABLE", "parameter_list");
    mandateFlag = validateField(parameterListValues.parameterListName, setParameterListNameErr) || mandateFlag;
    mandateFlag = validateField(parameterListValues.parameterListCode, setParameterListCodeErr) || mandateFlag;
    mandateFlag = validateField(parameterListValues.parameterListSequence, setParameterListSequenceErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    parameterListValues.parameterListCode = parameterListValues.parameterListCode.toUpperCase()
    const apiFunction = parameterId !== undefined ? saveParameterList:updateParameterListByID 
    apiFunction(parameterListValues, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, '/parameter/editParameter/' + parameterListValues.parameterId);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={8} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <MDBox 
              //  pt={4} 
              //  pb={3} 
              p={1.6}
              mb={0.9}
               px={2}>
                <Grid container columnSpacing={4} rowSpacing={2}>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Parameter List Name"
                      variant="outlined"
                      fullWidth
                      autoFocus={true}
                      inputProps={{
                        pattern: "^[a-zA-Z0-9 ]+$",
                        maxLength: 50
                      }}
                      value={parameterListValues.parameterListName}
                      onChange={handleChange("parameterListName")}


                    />
                    <br />{parameterListNameErr ? <span style={errMsg}>Parameter List Name can't be blank</span> : ""}
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Parameter List Code"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        // pattern: "^[A-Z0-9 ]+$",
                        maxLength: 20
                      }}
                      value={parameterListValues.parameterListCode}
                      onChange={handleChange("parameterListCode")}
                    />
                    {parameterListCodeErr ? <span style={errMsg}>Parameter List Code can't be blank</span> : ""}
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Parameter List Sequence"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: 5
                      }}
                      value={parameterListValues.parameterListSequence}
                      onChange={handleChange("parameterListSequence")}

                    />
                    {parameterListSequenceErr ? <span style={errMsg}>Parameter List Sequence can't be blank</span> : ""}

                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Parameter Status</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        name="userType"
                        id="demo-simple-select"
                        disabled={id? true:false}
                        style={{ minHeight: "44.11px" }}
                        label="Parameter Status"
                        value={parameterListValues.parameterListStatus}
                        onChange={handleChange("parameterListStatus")}
                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Custom Value 1"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[a-zA-Z0-9 ]+$",
                        maxLength: 20
                      }}
                      value={parameterListValues.customValue1}
                      onChange={handleChange("customValue1")}
                    />

                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Custom Value 2"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[a-zA-Z0-9 ]+$",
                        maxLength: 20
                      }}
                      value={parameterListValues.customValue2}
                      onChange={handleChange("customValue2")}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Custom Value 3"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[a-zA-Z0-9 ]+$",
                        maxLength: 20
                      }}
                      value={parameterListValues.customValue3}
                      onChange={handleChange("customValue3")}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Custom Value 4"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[a-zA-Z0-9 ]+$",
                        maxLength: 20
                      }}
                      value={parameterListValues.customValue4}
                      onChange={handleChange("customValue4")}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          // columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <Link to={`/parameter/editParameter/${parameterListValues.parameterId}`}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                onClick={() => { sessionStorage.setItem("PARA_TABLE", "parameter_list"); }}
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <MDButton onClick={disableColor?blank:addParameterList} rel="noreferrer" variant="gradient" className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"} fullWidth    style={{ width: "165px", height: "40px" }}>
              Save
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default AddParameterLsit;
